// API Configuration
// Automatically detect production vs local environment

const API_URL = window.location.hostname.includes('onrender.com') || window.location.hostname.includes('fieldhouse')
  ? 'https://fieldhouse-api.onrender.com'
  : (process.env.REACT_APP_API_URL || 'http://localhost:5000');

export default API_URL;
